
import { NgModule } from '@angular/core';

import { BankMovimentEditProvider } from './bank-moviment-edit.provider';
import { BankMovimentListProvider } from './bank-moviment-list.provider';

export * from './bank-moviment-edit.provider';
export * from './bank-moviment-list.provider';

export {
  BankMovimentListProvider,
  BankMovimentEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    BankMovimentEditProvider,
    BankMovimentListProvider
  ]
})
export class BankMovimentBackendModule { }
